/** The most prestigious period first (decision 70): all time, then the month, then the week. */
const PRESTIGE = ["all", "month", "week"];
/** The frame a player wears, or null: their best podium place, all time first, then first place first. Pure. */
export function rankFrameFor(userId, podiums) {
    for (const period of PRESTIGE) {
        const place = podiums[period].indexOf(userId);
        if (place >= 0 && place < 3)
            return `${period}-${(place + 1)}`;
    }
    return null;
}
/** The top three of a ranked board, in rank order. Pure. */
export function podiumOf(entries) {
    return [...entries]
        .filter((entry) => entry.rank <= 3)
        .sort((a, b) => a.rank - b.rank)
        .map((entry) => entry.userId);
}
//# sourceMappingURL=rankFrame.js.map